import { useDataExtractionReport } from '@/context/DataExtractionReport';
import { useGetActionPlansByReport } from '@/hooks/useGetActionPlansByReport';

export const useActionPlansCount = () => {
	const { dataExtractionReport } = useDataExtractionReport();

	const evaluationsCount = dataExtractionReport?.selected_reports_count || 0;

	const reportType = dataExtractionReport?.custom_report?.report_type!;

	const { data: actionPlans, isLoading: isLoadingActionPlans } = useGetActionPlansByReport({
		organization_id: dataExtractionReport?.organization_id!,
		company_id: dataExtractionReport?.company_id!,
		report_type: reportType,
		sector_id: dataExtractionReport?.sector_id!,
		line_id: dataExtractionReport?.line_id!,
		workstation_id: dataExtractionReport?.workstation_id!,
		start_date: dataExtractionReport?.start_date!,
		end_date: dataExtractionReport?.end_date!,
		data_extraction_id: dataExtractionReport?.id!
	});

	return {
		evaluationsCount,
		actionPlansCount: actionPlans?.count || 0,
		isLoading: isLoadingActionPlans
	};
};
